import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { examTypeService } from '../services/examTypeService'

export const getAllExamtypes = createAsyncThunk(
  'examtype/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await examTypeService.getAll()
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneExamtype = createAsyncThunk(
  'examtype/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examTypeService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createExamtype = createAsyncThunk(
  'examtype/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examTypeService.createExamType(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const editExamtype = createAsyncThunk(
  'examtype/edit',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examTypeService.editExamType(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const deleteExamtype = createAsyncThunk(
  'examtype/delete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examTypeService.deleteOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'examtype',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllExamtypes.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllExamtypes.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllExamtypes.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneExamtype.pending]: (state) => {
      state.loading = true
    },
    [getOneExamtype.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneExamtype.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createExamtype.pending]: (state) => {
      state.loading = true
    },
    [createExamtype.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createExamtype.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [editExamtype.pending]: (state) => {
      state.loading = true
    },
    [editExamtype.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [editExamtype.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteExamtype.pending]: (state) => {
      state.loading = true
    },
    [deleteExamtype.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteExamtype.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
